import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
var _excluded = ["slices", "meta", "discountAmountFull"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useRouter } from 'next/router';
import { useState } from 'react';
import { API_SIGNUP, PAGE_CHECKOUT_REDIRECT, PAGE_INTRODUCTION_PANASONIC_YOHANA } from '@store/constants/routes';
import { BenefitsSection } from '@store/components/Pricing/BenefitsSection';
import { HeroSection } from '@store/components/Pricing/HeroSection';
import { TestimonialSection } from '@store/components/Pricing/TestimonialSection';
import DirectToPurchaseModal from '@store/components/PurchaseFlow/DirectToPurchaseModal';
import { QUERY_PARAM_REDIRECT_TO } from '@store/constants/queryParams';
import { Slices } from '@yoweb/prismic-slicemachine/components/Slices';
import { PricingTemplate } from '@yoweb/prismic-slicemachine/customtypes/PageTemplatePricing';
import { Spacer } from '@yoweb/ui/components/Spacer';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { useExternalConfig } from '@store/contexts/ExternalConfig';
import { usePersistedQueryParameters } from '@store/hooks/usePersistedQueryParameters';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PricingPage = function PricingPage(props) {
  usePersistedQueryParameters();

  var _useState = useState(false),
      isDirectPurchaseModalOpen = _useState[0],
      setIsDirectPurchaseModalOpen = _useState[1];

  var _useIntlMeta = useIntlMeta(),
      lcLocale = _useIntlMeta.lcLocale;

  var isJapanLocale = lcLocale === 'ja-jp';
  var router = useRouter();

  var slices = props.slices,
      meta = props.meta,
      discountAmountFull = props.discountAmountFull,
      rest = _objectWithoutProperties(props, _excluded);

  var _useExternalConfig = useExternalConfig(),
      _useExternalConfig$gl = _useExternalConfig.globalFeatures,
      enableWaitlist = _useExternalConfig$gl.enableWaitlist,
      enableSkipPostalValidation = _useExternalConfig$gl.enableSkipPostalValidation;

  var startPurchase = function startPurchase() {
    // For Japan only show the direct purchase modal if skip postal validation flag is disabled
    if (isJapanLocale && !enableSkipPostalValidation || enableWaitlist) {
      setIsDirectPurchaseModalOpen(true);
    } else {
      void router.push(isJapanLocale ? PAGE_INTRODUCTION_PANASONIC_YOHANA : "".concat(API_SIGNUP, "?").concat(QUERY_PARAM_REDIRECT_TO, "=").concat(PAGE_CHECKOUT_REDIRECT, "&"));
    }
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HeroSection, _objectSpread({
      onClickGetStarted: function onClickGetStarted() {
        return startPurchase();
      }
    }, rest)), !isJapanLocale ? /*#__PURE__*/_jsx(TestimonialSection, {}) : null, /*#__PURE__*/_jsx(BenefitsSection, _objectSpread({
      onClickGetStarted: function onClickGetStarted() {
        return startPurchase();
      },
      discountAmountFull: discountAmountFull
    }, rest)), /*#__PURE__*/_jsx(Spacer, {
      size: {
        _: 'none',
        md: 'normal1',
        lg: 'normal3'
      }
    }), /*#__PURE__*/_jsx(Slices, {
      slices: slices,
      meta: meta,
      template: PricingTemplate
    }), /*#__PURE__*/_jsx(Spacer, {
      size: {
        _: 'none',
        md: 'normal1',
        lg: 'normal3'
      }
    }), /*#__PURE__*/_jsx(DirectToPurchaseModal, {
      isOpen: isDirectPurchaseModalOpen,
      isWaitlistEnabled: enableWaitlist,
      onClose: function onClose() {
        return setIsDirectPurchaseModalOpen(false);
      }
    })]
  });
}; // Please do not remove the redirect unless marketing has giving okay


PricingPage.layout = {
  type: 'marketing',
  props: {
    bgColor: 'base000',
    withTransparentHeader: true
  }
};
export var __N_SSP = true;
export default _withSuperJSONPage(PricingPage);